import React from 'react'

export default () => (
  <div>
  <hr/>

  <img src='/static/images/banner.png' style={{float:"left"}} />
  お問い合わせ先: <a href='mailto:ikebukuro.sinsi@gmail.com'>池袋紳士</a>
  ブログ: <a href='http://sinsi.hatenablog.com/'>{'http://sinsi.hatenablog.com/'}</a>
  Twitter:<a href='https://twitter.com/ikb_sinsi'>ikb_sinsi</a><br/>
  Copyright© 池袋紳士 Icon made by <a href="http://www.freepik.com" title="Freepik">Freepik</a>
  from <a href="http://www.flaticon.com" title="Flaticon">www.flaticon.com</a>
  is licensed under <a href="http://creativecommons.org/licenses/by/3.0/" title="Creative Commons BY 3.0">CC BY 3.0</a>
  </div>
)



// WEBPACK FOOTER //
// ./components/footer.react.js